import React, { useEffect, useState } from "react";
import Layout from "../../../components/layouts/Layout";
import UserDetailHeader from "../../../components/user-detail/UserDetailHeader";
import DataTable from "react-data-table-component";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../components/general/ProgressComponent";
import { GET_LATEST_CARE_REVIEWS_REPORT } from "../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
import * as XLSX from "xlsx";
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';

import {
    getRecords,
    isSuccess,
    filterColumns,
    filterRowsByProperty,
    displayEnumProperty,
    // toastErrorMessages,
    catchAsync,
    // toastSuccessMessages,
    ExportButton,
} from "../../../helper/helper";
import moment from "moment";

function LatestCareReviews() {

    const [filteredRows, setFilteredRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const apiQuery = {
        sortproperty: "createdAt",
        sortorder: -1,
        offset: 0,
        query: {
            critarion: { active: true },
        },
    };

    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            // toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
        } else if (method === "get" && data?.status === isSuccess) {

            const staffMembers = data?.data?.careReviews

            const filteredRows = filterRowsByProperty(
                staffMembers,
                (row) => row?.userId?.name
            );
            // setUserData(filteredRows);
            setFilteredRows(filteredRows);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_LATEST_CARE_REVIEWS_REPORT, apiQuery);
        console.log("🚀 ~ fetchAllRecords ~ response:", response)

        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    const columns = [
        {
            name: "#",
            selector: (row, index) => (
                <span >
                    {index + 1}
                </span>
            ),
            width: "5%",
            center: true,
        },
        {
            name: "Service User",
            selector: (row) => {
                return (
                    <span className="usersNameInfo py-2">
                        <span className="userInfo">
                            <span className="nameBlock">
                                {row?.userId?.modelId?.suFirstMiddleName ? (
                                    <>
                                        {`${row?.userId?.modelId?.suFirstMiddleName} ${row?.userId?.modelId?.suLastName}`}
                                    </>
                                ) : (
                                    <span className="nameBlock">{`${row?.userId?.name}`}</span>
                                )}
                            </span>
                        </span>
                    </span>
                );
            },
            width: "25%",
        },
        {
            name: "Started Date",
            selector: (row) => {
                return (
                    <>
                        {moment(row?.createdAt).format("DD-MM-YYYY")}
                    </>
                );
            },
            wrap: true,
        },
        {
            name: "Completed Date",
            selector: (row) => {
                return row?.isReviewed ? (
                    <>
                        {row?.reviewedBy?.length > 0 ? (
                            row.reviewedBy.map((item, index) => (
                                <div key={index}>
                                    {moment(item?.reviewedUser?.reviewedTime).format("DD-MM-YYYY")}
                                </div>
                            ))
                        ) : (
                            <div>Not Reviewed</div>
                        )}
                    </>
                ) : (
                    <small>Not Completed</small>
                );
            },
            wrap: true,
            center: true,
        },
        {
            name: "Completed By",
            selector: (row) => {
                return row?.isReviewed ? (
                    <>
                        {row?.reviewedBy?.length > 0 ? (
                            row.reviewedBy.map((item, index) => (
                                <div key={index}>
                                    {item?.reviewedUser?.name} {" "}{item?.reviewedUser?.modelId?.lastName}
                                </div>
                            ))
                        ) : (
                            <div>No Reviewer</div>
                        )}
                    </>
                ) : (
                    <small>Not Completed</small>
                );
            },
            wrap: true,
            center: true,
        },
        {
            name: "Next Care Review Date",
            selector: (row) => {
                return row?.isReviewed ? (
                    <>
                        {row?.reviewedBy?.length > 0 ? (
                            row.reviewedBy.map((item, index) => (
                                <div key={index}>
                                    {moment(item?.reviewedUser?.reviewedTime).add(30, 'days').format("DD-MM-YYYY")}
                                </div>
                            ))
                        ) : (
                            <div>-</div>
                        )}
                    </>
                ) : (
                    <small>-</small>
                );
            },
            wrap: true,
            center: true,
        },
    ];

    const filteredColumns = filterColumns(columns, (column) => column !== null);


    // Export Data

    const styles = StyleSheet.create({
        pages: {
            padding: "10px",
        },
        sectionTitle: {
            fontSize: "16px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        sectionSubTitle: {
            fontSize: "14px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        tableHead: {
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#f0f0f0",
            padding: "10px 10px",
            marginBottom: "5px",
            fontSize: "10px",
            fontWeight: "bold",
            wordWrap: "break-word",
        },
        tabBody: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px",
            borderBottom: "1px solid #ccc",
            fontSize: "10px",
            wordWrap: "break-word",
        },
        wordwrap: {
            flexBasis: "50%",
            wordWrap: "break-word",
        },
    });

    const MyDocument = (start) => (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.pages}>
                <View>
                    <Text style={styles.sectionTitle}>Latest Care Reviews</Text>
                    <View style={styles.tableHead}>
                        <Text style={{ width: "25%" }}>Service User</Text>
                        <Text style={{ width: "25%" }}>Started Date</Text>
                        <Text style={{ width: "15%" }}>Completed Date</Text>
                        <Text style={{ width: "15%" }}>Completed By</Text>
                        <Text style={{ width: "20%" }}>Next Care Review Date</Text>
                    </View>
                    {filteredRows.map((row, index) => (
                        <View key={index} style={styles.tabBody}>
                            <Text style={{ width: "25%" }}>
                                {
                                    `${row?.userId?.modelId?.suFirstMiddleName
                                        ? `${row.userId.modelId.suFirstMiddleName} ${row.userId.modelId.suLastName}`
                                        : row?.userId?.name || ""}`
                                }
                            </Text>
                            <Text style={{ width: "25%" }}>
                                {moment(row.createdAt).format("DD/MM/YYYY")}
                            </Text>
                            <Text style={{ width: "15%" }}>
                                {row?.reviewedBy?.length > 0 ? (
                                    row.reviewedBy.map((item, index) => (
                                        <Text key={index}>
                                            {moment(item?.reviewedUser?.reviewedTime).format("DD-MM-YYYY")}
                                        </Text>
                                    ))
                                ) : (
                                    <Text>Not Completed</Text>
                                )}
                            </Text>
                            <Text style={{ width: "15%" }}>
                                {row?.reviewedBy?.length > 0 ? (
                                    row.reviewedBy.map((item, index) => (
                                        <Text key={index}>
                                            {item?.reviewedUser?.name} {" "}{item?.reviewedUser?.modelId?.lastName}
                                        </Text>
                                    ))
                                ) : (
                                    <Text>Not Completed</Text>
                                )}
                            </Text>
                            <Text style={{ width: "20%" }}>
                                {row?.reviewedBy?.length > 0 ? (
                                    row.reviewedBy.map((item, index) => (
                                        <Text key={index}>
                                            {moment(item?.reviewedUser?.reviewedTime).add(30, 'days').format("DD-MM-YYYY")}
                                        </Text>
                                    ))
                                ) : (
                                    <Text>-</Text>
                                )}
                            </Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document >
    );

    const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
        const handleExport = () => {
            // Preprocess data to format dates before exporting
            const formattedData = data.map(
                ({
                    ...item
                }) => {


                    const serviceUserName = item?.userId?.modelId?.suFirstMiddleName
                        ? `${item?.userId?.modelId?.suFirstMiddleName} ${item?.userId?.modelId?.suLastName}`
                        : item?.userId?.name || '';

                    const reviewedBy = item?.reviewedBy?.length > 0
                        ? item.reviewedBy
                            .map(reviewer => {
                                const name = reviewer?.reviewedUser?.name || '';
                                const lastName = reviewer?.reviewedUser?.modelId?.lastName || '';
                                return lastName ? `${name} ${lastName}` : name;
                            })
                            .join(", ")
                        : "Not Completed";
                    const reviewedDate = item?.reviewedBy?.length > 0
                        ? item.reviewedBy
                            .map(item => moment(item?.reviewedUser?.reviewedTime).format("DD-MM-YYYY"))
                            .join(", ")
                        : "Not Completed";
                    const nextReviewedDate = item?.reviewedBy?.length > 0
                        ? item.reviewedBy
                            .map(item => moment(item?.reviewedUser?.reviewedTime).add(30, 'days').format("DD-MM-YYYY"))
                            .join(", ")
                        : "-";

                    removeMoreColumns.forEach((column) => {
                        delete item[column];
                    });
                    return {
                        ...item,
                        serviceUserName: serviceUserName,
                        completedBy: reviewedBy,
                        completedDate: reviewedDate,
                        nextReviewedDate: nextReviewedDate
                    };
                }
            );

            const formattedData2 = [{ "Latest Care Reviews": patientName }];

            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const fileName = patientName;

            // Convert dataWithTitles array to worksheet
            let ws = XLSX.utils.json_to_sheet(formattedData2);

            // Add second data set to existing worksheet
            const ws2 = XLSX.utils.json_to_sheet(formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: true,
            });

            XLSX.utils.sheet_add_json(ws, formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: false,
                origin: -1,
            });

            // Create workbook
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

            // Write workbook to array buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Convert array buffer to Blob
            const blob = new Blob([excelBuffer], { type: fileType });

            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName + fileExtension;
            a.click();
        };

        return <span onClick={handleExport}>Export as xlsx</span>;
    };
    return (
        <>
            <Layout pageTitleText="Latest Care Reviews">
                <header className="headerContainerSearchAction">
                    <div className="actionButtons">
                        <div className="gap-1">
                            <a className="btn btn-sm btn-primary" href="/reports">
                                Back to Reports
                            </a>
                            <>
                                {
                                    filteredRows.length > 0 && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                                                Export Data
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="exportDataList">
                                                <>
                                                    <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Latest Care Reviews"}>
                                                            {({ loading }) =>
                                                                loading ? '...' : 'Export as PDF'
                                                            }
                                                        </PDFDownloadLink>
                                                    </span>
                                                    <span className="">
                                                        <ExportButton data={filteredRows} patientName={"Latest Care Reviews"} removeMoreColumns={["userId", "addedby", "noteType", "title", "reviewedBy", "_id"]} />
                                                    </span>
                                                </>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                }
                            </>
                        </div>
                    </div>
                </header>

                {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
                    <MyDocument />
                </PDFViewer> */}
                <div className="mainContent noCursorPointer">
                    <div className="dataTableWrapper staffRecordsGroupsTable">
                        <DataTable
                            className="maxWidthTable"
                            columns={filteredColumns}
                            data={filteredRows}
                            fixedHeader
                            fixedHeaderScrollHeight="520px"
                            highlightOnHover
                            responsive={true}
                            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                            progressPending={isLoading}
                            progressComponent={<ProgressComponent />}
                        />
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default LatestCareReviews;
